import { Component, Injectable, OnInit, Input   } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ApiService } from '../../services/api.service';
import { IModalUpload } from '../../interfaces';
import { Location } from '@angular/common';
import { AlertService } from '../../vqutils/vq-alert/vq-alert.component';
import { FileUploader } from 'ng2-file-upload';
import { MIMES } from '../mimes';

import { BodyClassService } from '../body-class.service';

@Injectable()
export class ModalUploadService {

  constructor(
    private _location: Location,
    public _bc: BodyClassService,
    ) {}

  private _state = new Subject<any>();

  state = this._state.asObservable();

  open(data) {
    this._state.next({
      isOpen: true,
      data: data
    });
    this._bc.sendClasses('no-scroll');
  }

  close() {
    this._state.next({
      isOpen: false,
      data: {}
    });
    this._bc.sendClasses('no-scroll', false);
  }


  /************************************************************************
  ************************************************************************/
  upload(params: IModalUpload) {
    const data = {
      title: params.title,
      type : params.type,
      maxLength : params.maxLength,
      send : (value) => { if (params.send) { params.send(value); } }
    };
    this.open(data);
  }
}

@Component({
  selector: 'vq-modal-upload',
  templateUrl: './vq-modal-upload.component.html',
  styles: []
})
export class VQModalUploadComponent implements OnInit {

  // MODAL DATA
  @Input() data: any = {
      title: 'Upload',
      type: 'image',
      maxLength: 1,
      actions: [{
        action: () => this.valid(),
        label: 'Valider',
        color: 'secondary'
      }, {
        action: () => this.close(),
        label: 'Annuler',
        color: 'gray-light'
      }]
  };
  public isOpen = false;
  public files: any = [];

  // UPLOADER DATA
  public maxLength = 1;
  private _allowedMimeType: any = [];
  private _maxSize: number = 5 * 1024 * 1024;
  public isUploading = false;
  public hasBaseDropZoneOver = false;
  public uploader: FileUploader = new FileUploader({});

  constructor(
    private _ms: ModalUploadService,
    private _as: AlertService,
    private _api: ApiService
    ) { }

 // MODAL METHODS
  public close() {
    if (!this.isUploading) {
      this.data.send(this.files);
      this.isOpen = false;
      this._ms.close();
      this.uploader.destroy();
    }
  }

  public valid() {
    if (this.uploader.queue.length === 0) {
      this.close();
      return;
    }
    this.uploader.uploadAll();
  }

  public preventClick(event) {
    event.stopPropagation();
  }

  // Retrieve label by data type
  public getLabel() {
    let label = {
      single: 'pièce jointe',
      multiple: 'pièces jointes'
    };
    if (this.data.type === 'image') {
      label.single = 'image';
      label.multiple = 'images';
    } else if (this.data.type === 'video') {
      label.single = 'vidéo';
      label.multiple = 'vidéos';
    }
    return ( this.uploader.queue.length < 2) ? label.single : label.multiple;
  }

 // UPLOADER METHODS

 // Hover effect
  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  // Items callback to set alias before upload : ("image/video/attachment")
  private _initAlias() {
    this.uploader.onBeforeUploadItem = (item => {
      let alias = 'attachment';
      if (item.file.type.match('image.*')) {
        alias = 'image';
      }/*else if(item.file.type.match('video.*')){
        alias = 'video';
      }*/
      item.alias = alias;
      item.withCredentials = false;
    });
  }

  // Items callback to add to files array
  private _initAdd() {
    this.uploader.onSuccessItem = (item => {
      this.files.push({
        file : item,
        _xhr : JSON.parse(item._xhr.response)
      });
    });
  }

  private _initFinish() {
    this.uploader.onCompleteAll = (() => {
      if (!this.isUploading) {
        setTimeout(() => {
          this._as.success('Votre/vos éléments ont bien été uploadés.');
          this.close();
        }, 400);
      }
    });
    this.uploader.onProgressAll = ((progress) => {
      this.isUploading = true;
      if (progress === 100) {
        this.isUploading = false;
      }
    });
  }

  // Items callback when files add fails due invalid size,format or quantity
  private _initFail() {
    this.uploader.onWhenAddingFileFailed = (fileItem) => {
      if (fileItem.size > this._maxSize) {
        this._as.danger('Le poids de votre fichier n\'est pas valide.');
      } else if (this.uploader.queue.length > this.maxLength) {
        this._as.danger('Vous avez atteint le nombre maximum d\'éléments pouvant être uploadés.');
      } else {
        this._as.danger('Le format de votre fichier n\'est pas valide.');
      }
    };
  }

  // Init uploader
  private _initUploader(data) {
    this.files = [];
    this.maxLength = data.maxLength;
    const options = {
      url: this._api.retrieveUrl('/medias'),
      authToken : 'Token ' + this._api.getToken(),
      allowedMimeType: MIMES[data.type],
      // maxFileSize: this._maxSize
    };
    if (!this.maxLength && this.maxLength !== 0) {
      this.maxLength = ( data.type === 'image' ) ? 4 : 1;
      options['queueLimit'] = this.maxLength;
    }
    this.uploader = new FileUploader(options);
    this._initAlias();
    this._initFail();
    this._initAdd();
    this._initFinish();
  }

  // Init component
  ngOnInit() {
    this._ms.state.subscribe((v) => {
      this.isOpen = v.isOpen;
      this.data = Object.assign(this.data, v.data);
      this._initUploader(this.data);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/vqutils/vq-modal/vq-modal-upload.component.ts